import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { Image } from '@design-system/image';
import { AVATAR_STATE } from '../constants';
import { getStateIcon } from '../utils';
const IconWrapper = styled(Box) `
  align-items: center;
  border-radius: 50%;
  bottom: 0;
  display: flex;
  justify-content: center;
  right: 0;
`;
const DeceasedWrapper = styled(Box) `
  background-color: rgba(0, 0, 0, 0.2);
  bottom: 0;
  border-radius: 50%;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 18%;
    left: -22%;
    transform: rotate(-45deg);
    width: 100%;
    height: 20%;
    background-color: ${({ theme }) => theme.colors.black};
  }
`;
export const Picture = ({ alt, dataTestId, fallback, onError, onLoad, src, state, }) => {
    const icon = getStateIcon(state);
    return (_jsxs(_Fragment, { children: [_jsx(Image, { alt: alt, "data-testid": dataTestId, fallback: fallback, onError: onError, onLoad: onLoad, src: src }), icon ? (_jsx(IconWrapper, { bg: icon.bgColor || 'white', color: icon.color, "data-testid": `${state}-picture`, position: "absolute", size: "44%", children: _jsx(FontAwesomeIcon, { color: icon.color, height: icon.size || '100%', iconName: icon.name, iconType: CATEGORIES.SOLID }) })) : null, state === AVATAR_STATE.deceased ? (_jsx(DeceasedWrapper, { "data-testid": "deceased-picture" })) : null] }));
};
//# sourceMappingURL=Picture.js.map